<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="1530"
    content-class="fill-height requestModal">
    <v-card
      width="1530"
      max-height="945"
      class="fill-height d-flex flex-row overflow-y-auto">
      <div
        v-if="$vuetify.breakpoint.mdAndDown"
        style="position: relative; display: inline-block; width: 120px;">
        <div
          class="morph-wrapper"
          @mouseenter="showData = true"
          @mouseleave="showData = false">
          <div
            class="morph-button primary"
            :class="{
                'coverage-expanded': majorityStatus === 'COVERAGE' && showData,
                'exclusion-expanded': majorityStatus === 'EXCLUSION' && showData
              }">
            <template v-if="showData">
              <div
                class="card-fade">
                <CoverageCard v-if="majorityStatus === 'COVERAGE'" />
                <ExclusionCard v-if="majorityStatus === 'EXCLUSION'" />
              </div>
            </template>
            <template v-else>
              <span class="button-label">Ver dados</span>
            </template>
          </div>
        </div>
      </div>

      <CoverageCard v-if="$vuetify.breakpoint.lgAndUp && majorityStatus === 'COVERAGE'" />

      <ExclusionCard v-if="$vuetify.breakpoint.lgAndUp && majorityStatus === 'EXCLUSION'" />

      <v-card
        width="100%"
        min-width="500"
        class="elevation-0 fill-height rounded-0 d-flex flex-column justify-space-between"
        style="padding: 35px; min-height: 850px;">
        <div
          class="d-flex flex-column">
          <v-row
            class="d-flex justify-end">
            <v-col
              cols="9">
              <span
                class="primary--text font-weight-medium"
                style="font-size: 18px;">
                Preencha os campos abaixo para solicitar a
                {{ majorityStatus === 'EXCLUSION' ? 'exclusão' : 'permanência' }}:
              </span>
            </v-col>
            <v-col
              class="d-flex justify-end">
              <v-icon
                size="25"
                color="muted-accent"
                @click="closeModal">
                close
              </v-icon>
            </v-col>
          </v-row>

          <v-form
            ref="RequestFormRef">
            <v-row
              style="padding-top: 30px;">
              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
                v-if="majorityStatus === 'EXCLUSION'">
                <Textfield
                  label="Motivo da exclusão *"
                  :value="requestForm.exclusionReasonCode"
                  regular
                  disabled
                  :rules="[rule.required]"
                />
              </v-col>

              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
                v-if="majorityStatus === 'COVERAGE'">
                <Autocomplete
                  label="Motivo da permanência *"
                  :items="coverages"
                  item-value="id"
                  item-text="description"
                  :value="requestForm.coverageExtensionReason"
                  @change="setRequestForm({coverageExtensionReason: $event})"
                  :hint="previousCoverageExtensionReasonMessage"
                  :persistent-hint="hasPreviousCoverageExtensionReason"
                  regular
                  :rules="[rule.required]"
                  color="primary"
                  item-color="primary"
                />
              </v-col>

              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
                <Textfield
                  v-if="majorityStatus === 'EXCLUSION'"
                  label="Data Fim de Vigência *"
                  :value="requestForm.endDate"
                  placeholder="00/00/0000"
                  v-mask="'##/##/####'"
                  @input="setRequestForm({endDate: $event})"
                  :rules="endDateRules"
                  regular
                />

                <Textfield
                  v-if="majorityStatus === 'COVERAGE'"
                  :label="`Data Limite ${ limitDateFieldRules ? '*' : '' }`"
                  :value="requestForm.coverageExtensionLimitDate"
                  :hint="previousCoverageExtensionLimitDateMessage"
                  :persistent-hint="hasPreviousCoverageExtensionLimitDate"
                  @input="setRequestForm({coverageExtensionLimitDate: $event})"
                  placeholder="00/00/0000"
                  v-mask="'##/##/####'"
                  regular
                  :rules="limitDateFieldRules
                    ? limitDateRules
                    : requestForm.coverageExtensionLimitDate
                      ? isLimitDateValid
                      : []"
                />
              </v-col>

              <v-col
                cols="12"
                class="pt-0"
                v-if="coverageRules">
                <div
                  style="max-width: 250px;">
                  <v-checkbox
                    class="mt-0 pt-0"
                    :value="requestForm.isCoverageLimitIndefinite"
                    @click="setRequestForm({isCoverageLimitIndefinite: !requestForm.isCoverageLimitIndefinite})"
                    :label="`Permanência indeterminada ${ indefiniteFieldRules ? '*' : '' }`"
                    color="primary"
                    :rules="indefiniteFieldRules
                      ? [rule.required]
                      : []"
                  />
                </div>
              </v-col>

              <v-col
                cols="12">
                <Textfield
                  label="Comentário"
                  :value="requestForm.comment"
                  @input="setRequestForm({comment: $event})"
                  regular
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-column">
                <Documents
                  ref="Documents"
                  @documentsLoaded="documentsLoaded = true"
                  @isLoadingFile="isLoadingFile = $event"
                />
              </v-col>
            </v-row>
          </v-form>
        </div>

        <div
          style="padding-top: 30px;">
          <v-row
            :class="{
              'd-flex justify-center': true,
            }">
            <v-col
              class="d-flex justify-end">
              <v-btn
                outlined
                color="primary"
                :style="btnAction.style"
                @click="closeModal">
                Cancelar
              </v-btn>
            </v-col>

            <v-col
              class="d-flex justify-start">
              <v-btn
                color="primary"
                :disabled="onMakeRequestDisabled"
                :style="btnAction.style"
                @click="makeRequest">
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import MajorityRules from '../rules/majorityRules';
import Rules from '@/shared/validators/formRules';
import ExclusionCard from './ExclusionCard.vue';
import CoverageCard from './CoverageCard.vue';
import Autocomplete from './MajorityAutocomplete.vue';
import TwoLineCell from '@/components/Default/TwoLineCell.vue';
import Textfield from './MajorityTextfield.vue';
import Documents from './Documents.vue';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  name: "RequestModal",

  components: {
    ExclusionCard,
    CoverageCard,
    Autocomplete,
    TwoLineCell,
    Textfield,
    Documents,
  },

  data: () => ({
    rule: null,
    internalCriticisms: [],
    movementRecordId: null,
    documentsLoaded: false,
    isLoadingFile: false,
    showData: false,
    moment,
  }),

  mixins: [
    MajorityRules,
    MajorityMixin,
  ],

  methods: {
    ...mapActions({
      requestExclusion: 'majority/requestExclusion',
      requestCoverage: 'majority/requestCoverage',
      fetchMajorities: 'majority/fetchMajorities',
    }),

    ...mapMutations({
      hideRequestModal: 'majority/hideRequestModal',
      setRequestForm: 'majority/setRequestForm',
      loadingPage: 'majority/loadingPage',
    }),

    closeModal() {
      this.documentsLoaded = false;
      this.hideRequestModal();
    },

    async makeRequest() {
      if (!this.$refs.RequestFormRef.validate()) return;
      if (!this.$refs.Documents.filesValidation()) return;

      this.loadingPage(true);

      if (this.majorityStatus === 'COVERAGE') {
        await this.requestCoverage()
          .then((result) => this.movementRecordId = result.data.movementRecordId)
          .then(() => this.showMessage('success', 'Solicitação de Permanência enviada com sucesso!'))
          .then(async () => {
            await this.fetchMajorities();
            this.closeModal();
          })
          .catch((error) => this.showMessage('error', 'Ocorreu um erro ao tentar solicitar a Permanência!'))
          .finally(() => this.loadingPage(false));
      }

      if (this.majorityStatus === 'EXCLUSION') {
        await this.requestExclusion()
          .then((result) => this.movementRecordId = result.data.movementRecordId)
          .then(() => this.showMessage('success', 'Solicitação de Exclusão enviada com sucesso!'))
          .then(async () => {
            await this.fetchMajorities();
            this.closeModal();
          })
          .catch((error) => this.showMessage('error', 'Ocorreu um erro ao tentar solicitar a Exclusão!'))
          .finally(() => this.loadingPage(false));
      }
    },

    showMessage(statusMessage, message) {
      const majoritySnackbar = this.majorityViewReference()?.$refs.MajoritySnackbar || false;

      majoritySnackbar.open(
        statusMessage,
        message
      );
    },
  },

  computed: {
    ...mapGetters({
      majorityStatus: 'majority/majorityStatus',
      beneficiary: 'majority/beneficiary',
      requestForm: 'majority/requestForm',
      coverages: 'majority/coverages',
      show: 'majority/showModal',
    }),

    previousCoverageExtensionReasonMessage() {
      if (!this.hasPreviousCoverageExtensionReason) return '';

      const coverage = this.coverages.find(
        (coverage) => coverage.id == this.beneficiary.previousCoverageExtensionReason);

      return `Motivo de Permanência anterior: ${coverage.description}`
    },

    hasPreviousCoverageExtensionReason() {
      return this.beneficiary && this.beneficiary.previousCoverageExtensionReason;
    },

    previousCoverageExtensionLimitDateMessage() {
      if (!this.hasPreviousCoverageExtensionLimitDate) return '';

      return `Data limite anterior: ${
        moment(this.beneficiary.previousCoverageExtensionLimitDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }`;
    },

    hasPreviousCoverageExtensionLimitDate() {
      return this.beneficiary && this.beneficiary.previousCoverageExtensionLimitDate;
    },

    auxFieldsRules() {
      return this.validateCollegeSonRules ||
             this.validatePersonWithDisabilityOrCommercialConditionRules;
    },

    defaultAuxLabelRules() {
      if (!this.requestForm.coverageExtensionReason)
        return false;

      if (!this.coverageRules)
        return true;

      if (
        this.coverageRules
        && !this.requestForm.isCoverageLimitIndefinite &&
        !this.requestForm.coverageExtensionLimitDate
      )
        return true;

      return false;
    },

    limitDateFieldRules() {
      if (
        this.coverageRules
        && !this.requestForm.isCoverageLimitIndefinite &&
        this.requestForm.coverageExtensionLimitDate
      )
        return true;

      return this.defaultAuxLabelRules;
    },

    indefiniteFieldRules() {
      if (
        this.coverageRules
        && this.requestForm.isCoverageLimitIndefinite &&
        !this.requestForm.coverageExtensionLimitDate
      )
        return true;

      return this.defaultAuxLabelRules;
    },

    onMakeRequestDisabled() {
      if (!this.documentsLoaded) return true;
      if (this.isLoadingFile) return true;
      return false;
    },
  },

  created() {
    this.rule = new Rules();
  },
}
</script>

<style>
.requestModal {
  max-height: 850px !important;
}

.morph-wrapper {
  position: absolute;
  z-index: 9999;
}

.morph-button {
  color: var(--v-foreground-base);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  transition: all 0.4s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px;
}

.morph-button.coverage-expanded {
  width: 320px;
  height: 850px;
  border-radius: 0;
  margin: 0px !important;
}

.morph-button.exclusion-expanded {
  width: 500px;
  height: 850px;
  border-radius: 0;
  margin: 0px !important;
}

.button-label {
  font-weight: bold;
  font-size: 16px;
}

.card-fade {
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
  animation-delay: 0.3s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
</style>
